import $ from 'jquery';

/**
 * Improves the functionality of links depending on their URL's.
 *
 * @param context
 */
export default function rawCodeEnhancement(context=document.body) {
	const $context = $(context);

	$(function(){
		$('.code iframe').on('load', function() {
			console.log($(this).contents().height());
			$(this).css('width', '100%');
			$(this).css('min-height', '600px');
			// this.style.height = this.contentWindow.document.body.offsetHeight + 'px';
		});
	});
}



// WEBPACK FOOTER //
// ./source/scripts/enhancements/rawCode.js